(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const setValue = (root, selector, value) => {
    const element = root.querySelector(selector);
    if (element) element.textContent = pad(value);
  };

  const updateCountdown = (root) => {
    const launchAt = root.dataset.launchAt;
    const target = launchAt ? new Date(launchAt) : null;
    const finishedText = root.dataset.finishedText || 'LIVE NOW';
    const status = root.querySelector('[data-countdown-status]');

    if (!target || Number.isNaN(target.getTime())) {
      setValue(root, '[data-countdown-days]', 0);
      setValue(root, '[data-countdown-hours]', 0);
      setValue(root, '[data-countdown-minutes]', 0);
      setValue(root, '[data-countdown-seconds]', 0);
      return false;
    }

    const remaining = target.getTime() - Date.now();

    if (remaining <= 0) {
      root.classList.add('is-finished');
      if (status) status.textContent = finishedText;
      setValue(root, '[data-countdown-days]', 0);
      setValue(root, '[data-countdown-hours]', 0);
      setValue(root, '[data-countdown-minutes]', 0);
      setValue(root, '[data-countdown-seconds]', 0);
      return false;
    }

    const seconds = Math.floor(remaining / 1000);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    setValue(root, '[data-countdown-days]', days);
    setValue(root, '[data-countdown-hours]', hours);
    setValue(root, '[data-countdown-minutes]', minutes);
    setValue(root, '[data-countdown-seconds]', remainingSeconds);

    return true;
  };

  const initCountdowns = () => {
    document.querySelectorAll('[data-arosia-countdown]').forEach((root) => {
      if (!updateCountdown(root)) return;

      const interval = window.setInterval(() => {
        if (!updateCountdown(root)) window.clearInterval(interval);
      }, 1000);
    });
  };

  const initPasswordAccess = () => {
    const invalidPasswordInput = document.querySelector('.arosia-password-launch__access input[aria-invalid="true"]');
    if (!invalidPasswordInput) return;

    const access = invalidPasswordInput.closest('.arosia-password-launch__access');
    if (access) access.open = true;
  };

  const init = () => {
    initCountdowns();
    initPasswordAccess();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
